/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Site } from './Site';
import {
    SiteFromJSON,
    SiteFromJSONTyped,
    SiteToJSON,
    SiteToJSONTyped,
} from './Site';
import type { SimpleDataPoint } from './SimpleDataPoint';
import {
    SimpleDataPointFromJSON,
    SimpleDataPointFromJSONTyped,
    SimpleDataPointToJSON,
    SimpleDataPointToJSONTyped,
} from './SimpleDataPoint';
import type { Equipment } from './Equipment';
import {
    EquipmentFromJSON,
    EquipmentFromJSONTyped,
    EquipmentToJSON,
    EquipmentToJSONTyped,
} from './Equipment';
import type { EmissionEvent } from './EmissionEvent';
import {
    EmissionEventFromJSON,
    EmissionEventFromJSONTyped,
    EmissionEventToJSON,
    EmissionEventToJSONTyped,
} from './EmissionEvent';

/**
 * Serializer for listing data for EmissionMatch model.
 * @export
 * @interface EmissionRecordView
 */
export interface EmissionRecordView {
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordView
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof EmissionRecordView
     */
    readonly owner: number;
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordView
     */
    readonly ownerName: string;
    /**
     * 
     * @type {Site}
     * @memberof EmissionRecordView
     */
    site: Site;
    /**
     * 
     * @type {EmissionEvent}
     * @memberof EmissionRecordView
     */
    mainEvent: EmissionEvent;
    /**
     * 
     * @type {Array<Site>}
     * @memberof EmissionRecordView
     */
    siteMatches: Array<Site>;
    /**
     * 
     * @type {Equipment}
     * @memberof EmissionRecordView
     */
    equipment: Equipment;
    /**
     * 
     * @type {SimpleDataPoint}
     * @memberof EmissionRecordView
     */
    dataPoint: SimpleDataPoint;
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordView
     */
    readonly providerName: string;
    /**
     * 
     * @type {string}
     * @memberof EmissionRecordView
     */
    epaoperatornotification: string;
    /**
     * 
     * @type {Date}
     * @memberof EmissionRecordView
     */
    readonly createdAt: Date | null;
}

/**
 * Check if a given object implements the EmissionRecordView interface.
 */
export function instanceOfEmissionRecordView(value: object): value is EmissionRecordView {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('ownerName' in (value as Record<string, any>)) && !('owner_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerName'] === undefined && (value as Record<string, any>)['owner_name'] === undefined)) return false;
    if (!('site' in value) || value['site'] === undefined) return false;
    if ((!('mainEvent' in (value as Record<string, any>)) && !('main_event' in (value as Record<string, any>))) || ((value as Record<string, any>)['mainEvent'] === undefined && (value as Record<string, any>)['main_event'] === undefined)) return false;
    if ((!('siteMatches' in (value as Record<string, any>)) && !('site_matches' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteMatches'] === undefined && (value as Record<string, any>)['site_matches'] === undefined)) return false;
    if (!('equipment' in value) || value['equipment'] === undefined) return false;
    if ((!('dataPoint' in (value as Record<string, any>)) && !('data_point' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataPoint'] === undefined && (value as Record<string, any>)['data_point'] === undefined)) return false;
    if ((!('providerName' in (value as Record<string, any>)) && !('provider_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['providerName'] === undefined && (value as Record<string, any>)['provider_name'] === undefined)) return false;
    if (!('epaoperatornotification' in value) || value['epaoperatornotification'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function EmissionRecordViewFromJSON(json: any): EmissionRecordView {
    return EmissionRecordViewFromJSONTyped(json, false);
}

export function EmissionRecordViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionRecordView {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'ownerName': json['owner_name'],
        'site': SiteFromJSON(json['site']),
        'mainEvent': EmissionEventFromJSON(json['main_event']),
        'siteMatches': ((json['site_matches'] as Array<any>).map(SiteFromJSON)),
        'equipment': EquipmentFromJSON(json['equipment']),
        'dataPoint': SimpleDataPointFromJSON(json['data_point']),
        'providerName': json['provider_name'],
        'epaoperatornotification': json['epaoperatornotification'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
    };
}

export function EmissionRecordViewToJSON(json: any): EmissionRecordView {
    return EmissionRecordViewToJSONTyped(json, false);
}

export function EmissionRecordViewToJSONTyped(value?: Omit<EmissionRecordView, 'id'|'owner'|'ownerName'|'providerName'|'createdAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': SiteToJSON(value['site']),
        'main_event': EmissionEventToJSON(value['mainEvent']),
        'site_matches': ((value['siteMatches'] as Array<any>).map(SiteToJSON)),
        'equipment': EquipmentToJSON(value['equipment']),
        'data_point': SimpleDataPointToJSON(value['dataPoint']),
        'epaoperatornotification': value['epaoperatornotification'],
    };
}

